<template>
  <v-container fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm12 md11>
        <v-dialog v-model="dialog" max-width="600">
          <v-card>
            <v-toolbar flat dark color="primary">
              <v-toolbar-title>Email To</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text class="mt-10">
              <v-form ref="emailform" v-model="valid" lazy-validation>
                <v-text-field
                  prepend-inner-icon="mdi-file"
                  label="Reference"
                  type="text"
                  v-model="reference"
                  autofocus
                  dense
                  outlined
                ></v-text-field>
                <v-text-field
                  prepend-inner-icon="mdi-email"
                  label="Email Address"
                  type="email"
                  v-model="toemail"
                  :rules="toemailRules"
                  dense
                  outlined
                ></v-text-field>
                <v-text-field
                  prepend-inner-icon="mdi-email"
                  label="Cc"
                  type="email"
                  v-model="ccemail"
                  :rules="ccemailRules"
                  dense
                  outlined
                ></v-text-field>
                <div class="text-center">
                  <v-btn class="primary mr-2" text @click="close">Cancel</v-btn>
                  <v-btn text :disabled="!valid" @click="mailProposal"
                    >Send Email</v-btn
                  >
                </div>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-card class="elevation-12">
          <v-card-title class="primary white--text">
            <h2 class="headline ml-2">transformPNR Decoder</h2>
            <v-spacer></v-spacer>
            <span align-right>
              <small>{{ today | moment("dddd, MMMM Do YYYY H:mm:ss") }}</small>
            </span>
          </v-card-title>

          <v-card-text class="pa-10">
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-radio-group row v-model="gdsinuse">
                <v-radio
                  label="Amadeus"
                  :disabled="!activeAmadeus"
                  value="AMADEUS"
                ></v-radio>
                <v-radio
                  label="Galileo"
                  :disabled="!activeGalileo"
                  value="GALILEO"
                ></v-radio>
                <v-radio
                  label="Sabre"
                  :disabled="!activeSabre"
                  value="SABRE"
                ></v-radio>
              </v-radio-group>
              <v-textarea
                label="Itinerary"
                type="text"
                dense
                outlined
                rows="6"
                v-model="itinerary"
              ></v-textarea>

              <v-textarea
                label="Filed Fares"
                type="text"
                dense
                outlined
                rows="6"
                v-model="filedfares"
              ></v-textarea>
              <v-row>
                <v-col cols="5">
                  <v-radio-group row v-model="farebreakup">
                    <v-radio label="Grand Total Only" value="NETFARE"></v-radio>
                    <v-radio label="Breakup Totals" value="DETFARE"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="7">
                  <v-switch
                    v-model="showrules"
                    :label="`Show Fare Rules`"
                  ></v-switch>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    label="Local Currency"
                    :items="currencies"
                    v-model="currencylocal"
                    dense
                    outlined
                  ></v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    label="Fare"
                    :prefix="this.currencylocal"
                    value="0"
                    @keypress="isNumber($event, airfare)"
                    v-on:change="(event) => calcTotalPrice(event)"
                    v-model.number="airfare"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    label="Tax"
                    :prefix="this.currencylocal"
                    value="0"
                    @keypress="isNumber($event, tax)"
                    v-on:change="(event) => calcTotalPrice(event)"
                    v-model.number="tax"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    label="Service Fee"
                    :prefix="this.currencylocal"
                    value="0"
                    @keypress="isNumber($event, servicefee)"
                    v-on:change="(event) => calcTotalPrice(event)"
                    v-model.number="servicefee"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    label="Total Fare"
                    :prefix="this.currencylocal"
                    type="text"
                    v-model="customtotal"
                    readonly
                    dense
                    outlined
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    label="Baggage Allowance"
                    type="text"
                    v-model="baggage"
                    :rules="baggageRules"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-card>
                <v-tabs flat centered v-model="rulestabs" class="pa-5">
                  <v-tab href="#fares-manual" class="primary--text"
                    >Custom Fares</v-tab
                  >
                  <v-tab href="#fares-cummulative" class="primary--text"
                    >Cummulative Fares</v-tab
                  >
                  <v-tab href="#fares-segment" class="primary--text"
                    >Split Filed Fares</v-tab
                  >
                </v-tabs>

                <v-tabs-items centered v-model="rulestabs">
                  <v-tab-item value="fares-manual">
                    <v-card v-if="this.showrules" flat>
                      <v-card-text>
                        <!-- MANUAL FARE RULES -->
                        <v-simple-table
                          v-if="this.segments.length"
                          class="mb-10"
                          style="min-width: 100%"
                        >
                          <colgroup>
                            <col span="1" style="width: 10%" />
                            <col span="1" style="width: 10%" />
                            <col span="1" style="width: 80%" />
                          </colgroup>
                          <tr>
                            <td style="text-align: center">
                              <strong>Airline</strong>
                            </td>
                            <td style="text-align: left">
                              <strong>Flight No.</strong>
                            </td>
                            <td>
                              <strong>Fare Rules</strong>
                            </td>
                          </tr>
                          <tr
                            v-for="segment in this.segments"
                            :key="segment.index"
                          >
                            <td style="text-align: center">
                              {{ segment.iatacode }}
                            </td>
                            <td style="text-align: left">
                              {{ segment.flightno }}
                            </td>
                            <td>
                              <v-select
                                class="pt-5"
                                v-model="segment.farerule"
                                :items="farerules"
                                :menu-props="{ maxHeight: '300' }"
                                max-height="auto"
                                multiple
                                autocomplete
                                outlined
                                dense
                              ></v-select>
                            </td>
                          </tr>
                        </v-simple-table>

                        <div v-else>
                          <p class="text-center">
                            No data exists. Copy an itinerary from the GDS and
                            paste it in the itinerary box above.
                          </p>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item value="fares-cummulative">
                    <v-card v-if="this.showrules" flat>
                      <v-card-text>
                        <!-- CUMMULATIVE FARE RULES -->
                        <v-simple-table
                          v-if="this.tstfares.length"
                          class="mb-10"
                          style="min-width: 100%"
                        >
                          <colgroup>
                            <col span="1" style="width: 10%" />
                            <col span="1" style="width: 90%" />
                          </colgroup>
                          <tr>
                            <td style="text-align: center">
                              <strong>Item</strong>
                            </td>
                            <td>
                              <strong>Fare Rules</strong>
                            </td>
                          </tr>
                          <tr
                            v-for="tstfare in this.tstfares"
                            :key="tstfare.index"
                          >
                            <td style="text-align: center">
                              {{ tstfare.segment }}
                            </td>
                            <td>
                              <v-select
                                class="pt-5"
                                v-model="tstfare.farerule"
                                :items="farerules"
                                :menu-props="{ maxHeight: '300' }"
                                max-height="auto"
                                multiple
                                autocomplete
                                outlined
                                dense
                              ></v-select>
                            </td>
                          </tr>
                        </v-simple-table>

                        <div v-else>
                          <p class="text-center">
                            No data exists. Copy fare data from the GDS and
                            paste it in the filed fare box above.
                          </p>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item value="fares-segment">
                    <v-card v-if="this.showrules" flat>
                      <v-card-text>
                        <!-- SEGMENT-WISE FARE RULES -->
                        <v-simple-table
                          v-if="this.tstfares.length"
                          class="mb-10"
                          style="min-width: 100%"
                        >
                          <colgroup>
                            <col span="1" style="width: 10%" />
                            <col span="1" style="width: 10%" />
                            <col span="1" style="width: 80%" />
                          </colgroup>
                          <tr>
                            <td style="text-align: center">
                              <strong>Item</strong>
                            </td>
                            <td style="text-align: right">
                              <strong>Fare {{ this.currencylocal }}</strong>
                            </td>
                            <td>
                              <strong>Fare Rules</strong>
                            </td>
                          </tr>
                          <tr
                            v-for="tstfare in this.tstfares"
                            :key="tstfare.index"
                          >
                            <td style="text-align: center">
                              {{ tstfare.segment }}
                            </td>
                            <td style="text-align: right">
                              {{ tstfare.price }}
                            </td>

                            <td>
                              <v-select
                                class="pa-0 ma-0"
                                v-model="tstfare.farerule"
                                :items="farerules"
                                :menu-props="{ maxHeight: '300' }"
                                max-height="auto"
                                multiple
                                autocomplete
                                outlined
                                dense
                                auto-width
                              ></v-select>
                            </td>
                          </tr>
                        </v-simple-table>

                        <div v-else>
                          <p class="text-center">
                            No data exists. Copy fare data from the GDS and
                            paste it in the filed fare box above.
                          </p>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-card>
              <div class="pt-10">
                <v-text-field
                  label="Fare Validity"
                  type="text"
                  v-model="validity"
                  dense
                  outlined
                ></v-text-field>
              </div>
              <div class="pt-10">
                <v-textarea
                  label="Accomodation"
                  type="text"
                  dense
                  outlined
                  rows="6"
                  v-on:change="(event) => splitAccomodation(event)"
                  v-model="accomodation"
                ></v-textarea>
              </div>
              <div class="pt-10">
                <v-textarea
                  label="Notes"
                  type="text"
                  dense
                  outlined
                  rows="6"
                  v-on:change="(event) => splitNotes(event)"
                  v-model="notes"
                ></v-textarea>
              </div>
              <div class="text-center pb-10">
                <v-btn
                  class="mb-3 mr-2"
                  color="primary white--text"
                  :disabled="!valid"
                  @click="decodeItinerary"
                  >Decode</v-btn
                >
                <v-btn
                  class="mb-3"
                  color="primary white--text"
                  @click="resetForm"
                  >Reset</v-btn
                >
              </div>
            </v-form>
            <v-row>
              <v-col cols="12" align="center">
                <v-card>
                  <v-toolbar class="primary" dark>
                    <v-card-title class="primary white--text align-center">
                      <h2 class="headline ml-2">Proposal Preview</h2>
                    </v-card-title>
                    <v-progress-linear
                      :active="loading"
                      :indeterminate="loading"
                      color="red accent-4"
                      absolute
                      bottom
                    ></v-progress-linear>
                  </v-toolbar>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12">
                        <div
                          align="center"
                          ref="tocopy"
                          style="overflow-x: auto"
                        >
                          <table class="mb-5">
                            <colgroup>
                              <col span="1" style="width: 45px" />
                              <col span="1" style="width: 70px" />
                              <col span="1" style="width: 50px" />
                              <col span="1" style="width: 75px" />
                              <col span="1" style="width: 110px" />
                              <col span="1" style="width: 150px" />
                              <col span="1" style="width: 150px" />
                              <col span="1" style="width: 110px" />
                              <col span="1" style="width: 40px" />
                            </colgroup>
                            <tr
                              v-for="passenger in this.passengers"
                              :key="passenger.index"
                            >
                              <td colspan="9">{{ passenger.name }}</td>
                            </tr>
                            <tr>
                              <td>
                                <b>Item</b>
                              </td>
                              <td>
                                <b>Airline</b>
                              </td>
                              <td>
                                <b>Flt No.</b>
                              </td>
                              <td>
                                <b>Class</b>
                              </td>
                              <td>
                                <b>Departure</b>
                              </td>
                              <td>
                                <b>From</b>
                              </td>
                              <td>
                                <b>To</b>
                              </td>
                              <td>
                                <b>Arrival</b>
                              </td>
                              <td>
                                <b>Bags</b>
                              </td>
                            </tr>
                            <tr
                              v-for="itinerary in itineraries"
                              :key="itinerary.index"
                            >
                              <td>{{ itinerary.slno }}</td>
                              <td>{{ itinerary.airline }}</td>
                              <td>{{ itinerary.flightno }}</td>
                              <td>{{ itinerary.airclass }}</td>
                              <td>{{ itinerary.departure }}</td>
                              <td>{{ itinerary.fromairport }}</td>
                              <td>{{ itinerary.toairport }}</td>
                              <td>{{ itinerary.arrival }}</td>
                              <td>{{ itinerary.baggage }}</td>
                            </tr>
                            <tr
                              v-if="
                                this.rulestabs == 'fares-cummulative' ||
                                  this.rulestabs == 'fares-segment'
                              "
                            >
                              <td>
                                <strong>Fare Basis</strong>
                              </td>
                              <td colspan="8">{{ this.farebasis.trim() }}</td>
                            </tr>
                            <tr
                              v-if="
                                this.rulestabs == 'fares-manual' &&
                                  this.showrules
                              "
                            >
                              <td>
                                <strong>Fare Rules</strong>
                              </td>
                              <td colspan="8">
                                <table
                                  v-if="this.segments.length"
                                  style="width: 745px"
                                >
                                  <colgroup>
                                    <col span="1" style="width: 50px" />
                                    <col span="1" style="width: 75px" />
                                    <col span="1" style="width: 620px" />
                                  </colgroup>
                                  <tr>
                                    <td>
                                      <b>Airline</b>
                                    </td>
                                    <td>
                                      <b>Flight No.</b>
                                    </td>
                                    <td>
                                      <b>Fare Rules</b>
                                    </td>
                                  </tr>
                                  <tr
                                    v-for="segment in this.segments"
                                    :key="segment.index"
                                  >
                                    <td>{{ segment.iatacode }}</td>
                                    <td>{{ segment.flightno }}</td>
                                    <td>
                                      <div
                                        v-for="frule in segment.farerule"
                                        :key="frule.index"
                                      >
                                        {{ frule }}
                                      </div>
                                    </td>
                                  </tr>
                                </table>
                              </td>
                            </tr>
                            <tr
                              v-if="
                                this.rulestabs == 'fares-cummulative' &&
                                  this.showrules
                              "
                            >
                              <td>
                                <strong>Fare Rules</strong>
                              </td>
                              <td colspan="8">
                                <table
                                  v-if="this.tstfares.length"
                                  style="width: 745px"
                                >
                                  <colgroup>
                                    <col span="1" style="width: 50px" />
                                    <col span="1" style="width: 695px" />
                                  </colgroup>
                                  <tr>
                                    <td>
                                      <b>Item</b>
                                    </td>
                                    <td>
                                      <b>Fare Rules</b>
                                    </td>
                                  </tr>
                                  <tr
                                    v-for="tstfare in this.tstfares"
                                    :key="tstfare.index"
                                  >
                                    <td>{{ tstfare.segment }}</td>
                                    <td>
                                      <div
                                        v-for="frule in tstfare.farerule"
                                        :key="frule.index"
                                      >
                                        {{ frule }}
                                      </div>
                                    </td>
                                  </tr>
                                </table>
                              </td>
                            </tr>
                            <tr
                              v-if="
                                this.rulestabs == 'fares-segment' &&
                                  this.showrules
                              "
                            >
                              <td>
                                <strong>Fare {{ this.currencylocal }}</strong>
                              </td>
                              <td
                                colspan="8"
                                v-if="this.farebreakup == 'NETFARE'"
                              >
                                <table
                                  v-if="this.tstfares.length"
                                  style="width: 745px"
                                >
                                  <colgroup>
                                    <col span="1" style="width: 50px" />
                                    <col span="1" style="width: 75px" />
                                    <col span="1" style="width: 620px" />
                                  </colgroup>
                                  <tr>
                                    <td>
                                      <b>Item</b>
                                    </td>
                                    <td style="text-align: right">
                                      <b>Fare</b>
                                    </td>
                                    <td>
                                      <b>Fare Rules</b>
                                    </td>
                                  </tr>
                                  <tr
                                    v-for="tstfare in this.tstfares"
                                    :key="tstfare.index"
                                  >
                                    <td>{{ tstfare.segment }}</td>
                                    <td style="text-align: right">
                                      <b>{{ tstfare.total }}</b>
                                    </td>

                                    <td>
                                      <div
                                        v-for="frule in tstfare.farerule"
                                        :key="frule.index"
                                      >
                                        {{ frule }}
                                      </div>
                                    </td>
                                  </tr>
                                </table>
                              </td>
                              <td
                                colspan="8"
                                v-if="this.farebreakup == 'DETFARE'"
                              >
                                <table
                                  v-if="this.tstfares.length"
                                  style="width: 745px"
                                >
                                  <colgroup>
                                    <col span="1" style="width: 50px" />
                                    <col span="1" style="width: 75px" />
                                    <col span="1" style="width: 75px" />
                                    <col span="1" style="width: 75px" />
                                    <col span="1" style="width: 75px" />
                                    <col span="1" style="width: 395px" />
                                  </colgroup>
                                  <tr>
                                    <td>
                                      <b>Item</b>
                                    </td>
                                    <td style="text-align: right">
                                      <b>Base Fare</b>
                                    </td>
                                    <td style="text-align: right">
                                      <b>Tax</b>
                                    </td>
                                    <td style="text-align: right">
                                      <b>Service Fee</b>
                                    </td>
                                    <td style="text-align: right">
                                      <b>Grand Total</b>
                                    </td>
                                    <td>
                                      <b>Fare Rules</b>
                                    </td>
                                  </tr>
                                  <tr
                                    v-for="tstfare in this.tstfares"
                                    :key="tstfare.index"
                                  >
                                    <td>{{ tstfare.segment }}</td>
                                    <td style="text-align: right">
                                      <b>{{ tstfare.price }}</b>
                                    </td>
                                    <td style="text-align: right">
                                      <b>{{ tstfare.tax }}</b>
                                    </td>
                                    <td style="text-align: right">
                                      <b>{{ tstfare.servicefee }}</b>
                                    </td>
                                    <td style="text-align: right">
                                      <b>{{ tstfare.total }}</b>
                                    </td>
                                    <td>
                                      <div
                                        v-for="frule in tstfare.farerule"
                                        :key="frule.index"
                                      >
                                        {{ frule }}
                                      </div>
                                    </td>
                                  </tr>
                                </table>
                              </td>
                            </tr>

                            <tr
                              v-if="
                                this.rulestabs == 'fares-segment' &&
                                  !this.showrules
                              "
                            >
                              <td>
                                <strong>Fare {{ this.currencylocal }}</strong>
                              </td>
                              <td
                                colspan="8"
                                v-if="this.farebreakup == 'NETFARE'"
                              >
                                <table
                                  v-if="this.tstfares.length"
                                  style="width: 745px"
                                >
                                  <colgroup>
                                    <col span="1" style="width: 50px" />
                                    <col span="1" style="width: 655px" />
                                  </colgroup>
                                  <tr>
                                    <td>
                                      <b>Item</b>
                                    </td>
                                    <td style="text-align: right">
                                      <b>Total</b>
                                    </td>
                                  </tr>
                                  <tr
                                    v-for="tstfare in this.tstfares"
                                    :key="tstfare.index"
                                  >
                                    <td>{{ tstfare.segment }}</td>
                                    <td style="text-align: right">
                                      {{ tstfare.total }}
                                    </td>
                                  </tr>
                                </table>
                              </td>
                              <td
                                colspan="8"
                                v-if="this.farebreakup == 'DETFARE'"
                              >
                                <table
                                  v-if="this.tstfares.length"
                                  style="width: 745px"
                                >
                                  <colgroup>
                                    <col span="1" style="width: 50px" />
                                    <col span="1" style="width: 75px" />
                                    <col span="1" style="width: 75px" />
                                    <col span="1" style="width: 75px" />
                                    <col span="1" style="width: 80px" />
                                  </colgroup>
                                  <tr>
                                    <td>
                                      <b>Item</b>
                                    </td>
                                    <td style="text-align: right">
                                      <b>Base Fare</b>
                                    </td>
                                    <td style="text-align: right">
                                      <b>Tax</b>
                                    </td>
                                    <td style="text-align: right">
                                      <b>Service Fee</b>
                                    </td>
                                    <td style="text-align: right">
                                      <b>Grand Total</b>
                                    </td>
                                  </tr>
                                  <tr
                                    v-for="tstfare in this.tstfares"
                                    :key="tstfare.index"
                                  >
                                    <td>{{ tstfare.segment }}</td>
                                    <td style="text-align: right">
                                      {{ tstfare.price }}
                                    </td>
                                    <td style="text-align: right">
                                      {{ tstfare.tax }}
                                    </td>
                                    <td style="text-align: right">
                                      {{ tstfare.servicefee }}
                                    </td>
                                    <td style="text-align: right">
                                      {{ tstfare.total }}
                                    </td>
                                  </tr>
                                </table>
                              </td>
                            </tr>
                            <!-- Grand Total Manual Fares -->
                            <tr v-if="this.rulestabs == 'fares-manual'">
                              <td>
                                <strong>Fare {{ this.currencylocal }}</strong>
                              </td>
                              <td
                                colspan="8"
                                v-if="this.farebreakup == 'NETFARE'"
                              >
                                <b v-if="this.customtotal > 0">{{
                                  this.formatMoney(this.customtotal)
                                }}</b>
                              </td>
                              <td
                                colspan="8"
                                v-if="this.farebreakup == 'DETFARE'"
                              >
                                <table style="width: 745px">
                                  <tr>
                                    <td style="text-align: right">
                                      <strong>Base Fare</strong>
                                    </td>
                                    <td style="text-align: right">
                                      <strong>Tax</strong>
                                    </td>
                                    <td style="text-align: right">
                                      <strong>Service Fee</strong>
                                    </td>
                                    <td style="text-align: right">
                                      <strong>Grand Total</strong>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style="text-align: right">
                                      <strong>{{
                                        this.formatMoney(this.airfare)
                                      }}</strong>
                                    </td>
                                    <td style="text-align: right">
                                      <strong>
                                        {{ this.formatMoney(this.tax) }}</strong
                                      >
                                    </td>
                                    <td style="text-align: right">
                                      <strong>
                                        {{
                                          this.formatMoney(this.servicefee)
                                        }}</strong
                                      >
                                    </td>
                                    <td style="text-align: right">
                                      <strong>
                                        {{
                                          this.formatMoney(this.customtotal)
                                        }}</strong
                                      >
                                    </td>
                                  </tr>
                                </table>
                              </td>
                            </tr>
                            <!-- Grand Total Cummulative Fares -->
                            <tr v-if="this.rulestabs == 'fares-cummulative'">
                              <td>
                                <strong>Fare {{ this.currencylocal }}</strong>
                              </td>
                              <td
                                colspan="8"
                                v-if="this.farebreakup == 'NETFARE'"
                              >
                                <b v-if="this.cummulativetotal > 0">{{
                                  this.formatMoney(this.cummulativetotal)
                                }}</b>
                              </td>
                              <td
                                colspan="8"
                                v-if="this.farebreakup == 'DETFARE'"
                              >
                                <table style="width: 745px">
                                  <tr>
                                    <td style="text-align: right">
                                      <strong>Base Fare</strong>
                                    </td>
                                    <td style="text-align: right">
                                      <strong>Tax</strong>
                                    </td>
                                    <td style="text-align: right">
                                      <strong>Service Fee</strong>
                                    </td>
                                    <td style="text-align: right">
                                      <strong>Grand Total</strong>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td style="text-align: right">
                                      <strong>{{
                                        this.formatMoney(this.basic)
                                      }}</strong>
                                    </td>
                                    <td style="text-align: right">
                                      <strong>
                                        {{
                                          this.formatMoney(this.salestax)
                                        }}</strong
                                      >
                                    </td>
                                    <td style="text-align: right">
                                      <strong>
                                        {{
                                          this.formatMoney(this.servicefee)
                                        }}</strong
                                      >
                                    </td>
                                    <td style="text-align: right">
                                      <strong>
                                        {{
                                          this.formatMoney(
                                            this.cummulativetotal
                                          )
                                        }}</strong
                                      >
                                    </td>
                                  </tr>
                                </table>
                              </td>
                            </tr>
                            <tr>
                              <td><b>Valid</b></td>
                              <td colspan="8">{{ this.validity }}</td>
                            </tr>
                            <tr>
                              <td>
                                <b>Stay</b>
                              </td>
                              <td colspan="8">
                                <div
                                  v-for="hotel in this.hotels"
                                  :key="hotel.index"
                                >
                                  <p>{{ hotel }}</p>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <b>Notes</b>
                              </td>
                              <td colspan="8">
                                <div
                                  v-for="remark in this.remarks"
                                  :key="remark.index"
                                >
                                  <p>{{ remark }}</p>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td colspan="9">
                                Copyright &copy; 2020 transformPNR.&nbsp; Fares
                                quoted subject to availability and exchange
                                rates.
                                {{ today | moment("dddd, MMMM Do YYYY H:mm") }}
                              </td>
                            </tr>
                          </table>

                          <v-btn
                            class="mb-3 mr-2"
                            :disabled="!valid"
                            color="primary white--text"
                            @click="copyClipboard"
                            >Copy to Clipboard</v-btn
                          >
                          <v-btn
                            class="mb-3"
                            :disabled="!valid"
                            color="primary white--text"
                            @click="opendialog"
                            >Mail Direct</v-btn
                          >
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import AdminLayout from "@/layouts/AdminLayout.vue"
import axios from "axios"
import VCurrencyField from "@/components/VCurrencyField"
import firebase from "firebase/app"
import "firebase/auth"
import "firebase/firestore"

axios.defaults.baseURL = process.env.VUE_APP_ROOT_API

export default {
  components: {
    VCurrencyField,
  },
  data() {
    return {
      loading: false,
      dialog: false,
      valid: true,
      rulestabs: null,
      showrules: false,
      today: new Date(),
      company: "",
      activeusers: 0,
      noofusers: 0,
      gdsinuse: "AMADEUS",
      farebreakup: "NETFARE",
      activeAmadeus: false,
      activeGalileo: false,
      activeSabre: false,
      currencylocal: "",
      currencies: [],
      passengers: [],
      amadeusFlags: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9."],
      passengerFlags: [
        "1.1",
        "2.1",
        "3.1",
        "4.1",
        "5.1",
        "6.1",
        "7.1",
        "8.1",
        "9.1",
      ],
      itinerary: "",
      itineraries: [],
      filedfares: "",
      farerules: [],
      airfare: 0,
      tax: 0,
      servicefee: 0,
      baggage: "",
      baggageRules: [
        (v) =>
          v.length == 0 ||
          v.length == 3 ||
          "Baggage Allowance must 3 characters",
      ],
      validity: "",
      accomodation: "",
      hotels: [],
      notes: "",
      remarks: [],
      airstatus: [
        "AF",
        "AA",
        "AK",
        "AL",
        "AN",
        "BK",
        "BL",
        "BN",
        "CH",
        "CK",
        "CS",
        "DK",
        "DL",
        "DS",
        "DX",
        "EK",
        "FS",
        "GF",
        "GK",
        "GL",
        "GN",
        "GO",
        "HA",
        "HD",
        "HI",
        "HK",
        "HL",
        "HN",
        "HQ",
        "HS",
        "HW",
        "HX",
        "IG",
        "IH",
        "IK",
        "IN",
        "IS",
        "IX",
        "KD",
        "KK",
        "KL",
        "LK",
        "LL",
        "MB",
        "MK",
        "ML",
        "MN",
        "MO",
        "MR",
        "NA",
        "NN",
        "NO",
        "NS",
        "OB",
        "OX",
        "PA",
        "PB",
        "PC",
        "PD",
        "PK",
        "PN",
        "PS",
        "PW",
        "RR",
        "SB",
        "SC",
        "SD",
        "SP",
        "SQ",
        "SS",
        "TK",
        "TL",
        "TN",
        "UC",
        "UN",
        "US",
        "UU",
        "WK",
        "WL",
        "WN",
        "XB",
        "XI",
        "XK",
        "XM",
        "XX",
        "YG",
        "YK",
        "ZK",
      ],
      farebasis: "",
      faredetails: [],
      tstfares: [],
      segments: [],
      customtotal: 0,
      cummulativetotal: 0,
      basic: 0,
      salestax: 0,
      commission: 0,
      grandtotal: 0,
      toemail: "",
      toemailRules: [
        (v) => !!v || "Recipient email address is required",
        (v) => /.+@.+/.test(v) || "Recipient email must be valid",
      ],
      ccemail: "",
      ccemailRules: [
        (v) => !v || /.+@.+/.test(v) || "Recipient email must be valid",
      ],
      reference: "",
    }
  },

  watch: {
    dialog(val) {
      val || this.close()
    },

    itinerary(val) {
      if (val.trim().length > 0) {
        switch (this.gdsinuse) {
          case "AMADEUS":
            if (this.activeAmadeus) {
              if (this.checkAmadeus()) {
                this.amadeusSegments()
              } else {
                this.$vToastify.error(
                  `The itinerary is either invalid or incorrect. Try again.`,
                  "ERROR!"
                )
              }
            }
            break
          case "GALILEO":
            if (this.activeGalileo) {
              if (this.checkGalileo()) {
                this.galileoSegments()
              } else {
                this.$vToastify.error(
                  `The itinerary is either invalid or incorrect. Try again.`,
                  "ERROR!"
                )
              }
            }
            break
          case "SABRE":
            if (this.activeSabre) {
              if (this.checkSabre()) {
                this.sabreSegments()
              } else {
                this.$vToastify.error(
                  `The itinerary is either invalid or incorrect. Try again.`,
                  "ERROR!"
                )
              }
            }
            break
        }
      } else {
        this.segments = []
      }
    },

    filedfares(val) {
      if (val.trim().length > 0) {
        switch (this.gdsinuse) {
          case "AMADEUS":
            if (this.activeAmadeus) {
              if (this.checkFaresAmadeus()) {
                this.amadeusFares()
              } else {
                this.$vToastify.error(
                  `The filed fare is either invalid or incorrect. Try again.`,
                  "ERROR!"
                )
              }
            }
            break
          case "GALILEO":
            if (this.activeGalileo) {
              if (this.checkFaresGalileo()) {
                this.galileoFares()
              } else {
                this.$vToastify.error(
                  `The filed fare is either invalid or incorrect. Try again.`,
                  "ERROR!"
                )
              }
            }
            break
          case "SABRE":
            if (this.activeSabre) {
              if (this.checkFaresSabre()) {
                this.sabreFares()
              } else {
                this.$vToastify.error(
                  `The filed fare is either invalid or incorrect. Try again.`,
                  "ERROR!"
                )
              }
            }
            break
        }
      } else {
        this.faredetails = []
        this.tstfares = []
      }
    },
  },

  mounted() {
    var timerID = setInterval(this.updateTime, 1000)

    this.getUser()
    this.getCurrency()
    this.getFareRules()
  },

  created() {
    this.$emit(`update:layout`, AdminLayout)
  },

  methods: {
    opendialog() {
      this.valid = true
      this.dialog = true
    },

    close() {
      this.dialog = false
      this.valid = true
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    async getUser() {
      try {
        const uid = await firebase.auth().currentUser.uid
        const user = await firebase
          .firestore()
          .collection("users")
          .doc(uid)
          .get()
        if (user) {
          this.company = user.data().company
          this.noofusers = user.data().numusers
          this.activeusers = this.activeusers + 1
          this.currencylocal = user.data().currency
          this.activeAmadeus = user.data().amadeus
          this.activeGalileo = user.data().galileo
          this.activeSabre = user.data().sabre
          this.notes = user.data().notes
          this.remarks = user.data().notes.split("\n")
          this.ccemail = user.data().groupmail
        } else {
          this.company = ""
          this.noofusers = 0
          this.activeusers = 0
          this.currencylocal = ""
          this.activeAmadeus = false
          this.activeGalileo = false
          this.activeSabre = false
          this.notes = ""
          this.remarks = []
          this.ccemail = ""
        }
      } catch (e) {
        console.log(e)
      }
    },

    async getFareRules() {
      await firebase
        .firestore()
        .collection("farerules")
        .where("userid", "==", firebase.auth().currentUser.uid)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            const farerule = doc.data().rule
            this.farerules.push(farerule)
          })
        })
        .catch((error) => {
          console.error(error)
        })
    },

    // Check if itineraries are valid Amadeus itineraries
    checkAmadeus() {
      var isAmadeus = new Array()
      if (this.itinerary.length > 0) {
        const routeLine = this.itinerary.split("\n")
        for (let i = 0; i < routeLine.length; i++) {
          // Segment lines
          if (
            this.airstatus.includes(routeLine[i].substring(29, 31).trim()) &&
            parseInt(routeLine[i].substring(31, 32)) > 0
          ) {
            var aDate = routeLine[i].substring(14, 19).trim()
            if (
              isNaN(aDate.substring(0, 2)) ||
              this.convMonth(aDate.substring(2, 5)) == 0
            ) {
              isAmadeus.push("NO")
            } else {
              isAmadeus.push("YES")
            }
          }
        }
        if (isAmadeus.every((number) => number == "NO")) {
          return false
        } else {
          return true
        }
      }
    },

    // Check if itineraries are valid Galileo itineraries
    checkGalileo() {
      var isGalileo = new Array()
      if (this.itinerary.length > 0) {
        const routeLine = this.itinerary.split("\n")
        for (let i = 0; i < routeLine.length; i++) {
          // Segment lines
          if (
            this.airstatus.includes(routeLine[i].substring(29, 31).trim()) &&
            parseInt(routeLine[i].substring(31, 32)) > 0
          ) {
            var today = new Date()
            var gDate = routeLine[i].substring(16, 21).trim()
            if (
              isNaN(gDate.substring(0, 2)) ||
              this.convMonth(gDate.substring(2, 5)) == 0
            ) {
              isGalileo.push("NO")
            } else {
              isGalileo.push("YES")
            }
          }
        }
        if (isGalileo.every((number) => number == "NO")) {
          return false
        } else {
          return true
        }
      }
    },

    // Check if itineraries are valid Sabre itineraries
    checkSabre() {
      var isSabre = new Array()
      if (this.itinerary.length > 0) {
        const routeLine = this.itinerary.split("\n")
        for (let i = 0; i < routeLine.length; i++) {
          // Segment lines
          if (
            this.airstatus.includes(routeLine[i].substring(26, 28).trim()) &&
            parseInt(routeLine[i].substring(28, 29)) > 0
          ) {
            var today = new Date()
            var sDate = routeLine[i].substring(11, 16).trim()
            if (
              isNaN(sDate.substring(0, 2)) ||
              this.convMonth(sDate.substring(2, 5)) == 0
            ) {
              isSabre.push("NO")
            } else {
              isSabre.push("YES")
            }
          }
        }
        if (isSabre.every((number) => number == "NO")) {
          return false
        } else {
          return true
        }
      }
    },

    // Check if files fare is a valid Amadeus Fare
    checkFaresAmadeus() {
      if (this.filedfares.length > 0) {
        if (
          this.filedfares.search("TST") > -1 &&
          this.filedfares.search("FXP") > -1 &&
          this.filedfares.search("FARE") > -1 &&
          this.filedfares.search("TOTAL") > -1 &&
          this.filedfares.search("GRAND TOTAL") > -1
        ) {
          return true
        } else {
          return false
        }
      }
    },

    // Check if files fare is a valid Galileo Fare
    checkFaresGalileo() {
      if (this.filedfares.length > 0) {
        if (
          this.filedfares.search("FQ") > -1 &&
          this.filedfares.search("FARE") > -1 &&
          this.filedfares.search("SUBTOTAL") > -1 &&
          this.filedfares.search("GRAND TOTAL") > -1
        ) {
          return true
        } else {
          return false
        }
      }
    },

    // Check if files fare is a valid Sabre Fare
    checkFaresSabre() {
      if (this.filedfares.length > 0) {
        if (
          this.filedfares.search("PQ") > -1 &&
          this.filedfares.search("BASE FARE") > -1 &&
          this.filedfares.search("TAXES/FEES/CHARGES") > -1 &&
          this.filedfares.search("TOTAL") > -1 &&
          this.filedfares.search("ADT") > -1
        ) {
          return true
        } else {
          return false
        }
      }
    },

    // Extract Amadeus segments
    amadeusSegments() {
      this.segments = []
      this.passengers = []
      if (this.itinerary.length > 0) {
        const routeLine = this.itinerary.split("\n")
        for (let i = 0; i < routeLine.length; i++) {
          // Segment lines
          if (
            this.airstatus.includes(routeLine[i].substring(29, 31).trim()) &&
            parseInt(routeLine[i].substring(31, 32)) > 0
          ) {
            // Create Itinerary Object
            const segmentObj = {
              iatacode: routeLine[i].substring(5, 7).trim(),
              flightno: routeLine[i].substring(5, 11).trim(),
              farerule: "",
            }
            this.segments.push(segmentObj)
          }
        }
      }
    },

    // Extract Galileo segments
    galileoSegments() {
      this.segments = []
      this.passengers = []
      if (this.itinerary.length > 0) {
        const routeLine = this.itinerary.split("\n")
        for (let i = 0; i < routeLine.length; i++) {
          // Segment lines
          if (
            this.airstatus.includes(routeLine[i].substring(29, 31).trim()) &&
            parseInt(routeLine[i].substring(31, 32)) > 0
          ) {
            // Create Itinerary Object
            const segmentObj = {
              iatacode: routeLine[i].substring(5, 7).trim(),
              flightno:
                routeLine[i].substring(5, 7) + routeLine[i].substring(8, 12),
              farerule: "",
            }
            this.segments.push(segmentObj)
          }
        }
      }
    },

    // Extract Sabre segments
    sabreSegments() {
      this.segments = []
      this.passengers = []
      if (this.itinerary.length > 0) {
        const routeLine = this.itinerary.split("\n")
        for (let i = 0; i < routeLine.length; i++) {
          // Segment lines
          if (
            this.airstatus.includes(routeLine[i].substring(26, 28).trim()) &&
            parseInt(routeLine[i].substring(28, 29)) > 0
          ) {
            // Create Itinerary Object
            const segmentObj = {
              iatacode: routeLine[i].substring(3, 5).trim(),
              flightno: routeLine[i].substring(3, 9).trim(),
              farerule: "",
            }
            this.segments.push(segmentObj)
          }
        }
      }
    },

    // Extract & compute Amadeus fares
    amadeusFares() {
      this.farebasis = ""
      this.faredetails = []
      this.tstfares = []
      this.basic = 0
      this.salestax = 0
      this.commission = 0
      this.cummulativetotal = 0
      this.grandtotal = 0
      if (this.filedfares.length > 0) {
        const fareLine = this.filedfares.split("\n")
        for (var x = 0; x < fareLine.length; x++) {
          if (fareLine[x].substring(0, 3) == "TST") {
            var tstno = fareLine[x].substring(0, 8)
          }
          // Segment No.
          if (fareLine[x].substring(0, 3) == "FXP") {
            var segmt = fareLine[x].substring(5, fareLine[x].length)
          }

          if (
            parseInt(fareLine[x].substring(0, 3)) > 0 &&
            parseInt(fareLine[x].substring(0, 3)) <= 99 &&
            parseInt(fareLine[x].substring(12, 16)) > 0
          ) {
            // Flight No, Baggage Allowance, Fare Basis
            const tstObj = {
              tstno: tstno,
              segment: segmt,
              flightno: (
                fareLine[x].substring(9, 11) + fareLine[x].substring(12, 16)
              ).trim(),
              allowance: fareLine[x].substring(61, 64).trim(),
              farebasis: fareLine[x].substring(34, 42).trim(),
            }
            this.farebasis =
              this.farebasis + " " + fareLine[x].substring(34, 42)
            this.faredetails.push(tstObj)
          }

          // Fares and Taxes
          if (fareLine[x].substring(0, 4) == "FARE") {
            var price = parseFloat(fareLine[x].substring(12, 22).trim())
          }

          if (fareLine[x].substring(0, 5) == "EQUIV") {
            var price = parseFloat(fareLine[x].substring(12, 22).trim())
          }

          if (fareLine[x].substring(0, 5) == "TOTAL") {
            var total = parseFloat(fareLine[x].substring(12, 22).trim())
          }

          var tax = total - price

          // Grand Total
          if (fareLine[x].substring(0, 11) == "GRAND TOTAL") {
            const priceObj = {
              tstno: tstno,
              segment: segmt,
              price: this.formatMoney(price),
              tax: this.formatMoney(tax),
              subtotal: 0,
              tstfees: 0,
              tsttotal: 0,
              servicefee: this.formatMoney(this.servicefee),
              total: this.formatMoney(
                parseFloat(fareLine[x].substring(16, 26).trim()) +
                  this.servicefee
              ),
            }
            this.tstfares.push(priceObj)
            this.basic = this.basic + price
            this.salestax = this.salestax + tax
            this.commission = this.commission + this.servicefee
          }
        }
        this.cummulativetotal = this.basic + this.salestax + this.servicefee
        this.grandtotal = this.basic + this.salestax + this.commission
      }
    },

    // Extract and compute Galileo fares
    galileoFares() {
      this.farebasis = ""
      this.faredetails = []
      this.tstfares = []
      this.basic = 0
      this.salestax = 0
      this.commission = 0
      this.grandtotal = 0
      this.cummulativetotal = 0
      var basefare = ""
      var cost = 0
      var price = 0
      var equiv = ""
      var conv = 0
      var sbtotal = ""
      var subtotal = 0
      var srvfees = ""
      var fees = 0
      var tstotal = ""
      var tsttotal = 0
      if (this.filedfares.length > 0) {
        var fareLine = this.filedfares.split("\n")
        for (let l = 0; l < fareLine.length; l++) {
          if (
            fareLine[l].substring(0, 2) == "FQ" &&
            parseInt(fareLine[l].substring(2, 3)) > 0
          ) {
            //if (fareLine[l].substring(0, 3) != "FQC") {
            var tstno = fareLine[l].substring(0, 3)
            var segmt = fareLine[l].substring(8, 40).trim()
            //}
          }
          if (
            fareLine[l].substring(0, 1) == "S" &&
            parseInt(fareLine[l].substring(1, 2)) > 0
          ) {
            var allowance = fareLine[l].split(" ")
            const tstObj = {
              tstno: tstno,
              segment: segmt,
              segforbag: fareLine[l].substring(0, 2).trim(),
              farebasis: allowance[2].substring(3, allowance[2].length),
              allowance: allowance[3].substring(2, allowance[3].length),
            }
            this.farebasis =
              this.farebasis +
              " " +
              allowance[2].substring(3, allowance[2].length)
            this.faredetails.push(tstObj)
          }

          if (
            fareLine[l].substring(0, 4) === "FARE" &&
            fareLine[l].substring(0, 16) != "FARE RESTRICTION"
          ) {
            var priceLn = fareLine[l].split(" ")
            console.log(priceLn)
            for (var m = 0; m < priceLn.length; m++) {
              if (priceLn[m] === "FARE") {
                basefare = priceLn[m + 1].trim()
                basefare = basefare.substring(3, basefare.length)
              } else if (priceLn[m] === "EQU") {
                equiv = priceLn[m + 1].trim()
                equiv = equiv.substring(3, equiv.length)
              }
            }
          }

          if (fareLine[l].substring(0, 8) == "SUBTOTAL") {
            var subLn = fareLine[l].split(" ")
            for (var m = 0; m < subLn.length; m++) {
              if (subLn[m] == "SUBTOTAL") {
                sbtotal = subLn[m + 2]
                subtotal = isNaN(parseFloat(sbtotal)) ? 0 : parseFloat(sbtotal)
              } else if (subLn[m] == "TOTAL") {
                srvfees = subLn[m + 2]
                fees = isNaN(parseFloat(srvfees)) ? 0 : parseFloat(srvfees)
              } else if (subLn[m] == "GRAND") {
                tstotal = subLn[m + 2]
                tsttotal = isNaN(parseFloat(tstotal)) ? 0 : parseFloat(tstotal)
              }
            }

            if (parseFloat(equiv) > 0) {
              var tax = parseFloat(
                parseFloat(subtotal) - parseFloat(equiv)
              ).toFixed(2)
            } else {
              var tax = parseFloat(
                parseFloat(subtotal) - parseFloat(basefare)
              ).toFixed(2)
            }
            const priceObj = {
              tstno: tstno,
              segment: segmt,
              price:
                parseFloat(equiv) > 0
                  ? this.formatMoney(parseFloat(equiv))
                  : this.formatMoney(parseFloat(basefare)),
              tax: this.formatMoney(tax),
              subtotal: this.formatMoney(subtotal),
              tstfees: this.formatMoney(fees),
              tsttotal: this.formatMoney(tsttotal),
              servicefee: this.formatMoney(this.servicefee),
              total: this.formatMoney(tsttotal + this.servicefee),
            }
            this.tstfares.push(priceObj)
            this.basic = this.basic + price
            this.salestax = this.salestax + tax
            this.commission = this.commission + fees + this.servicefee
          }
        }
        this.cummulativetotal =
          this.basic + this.salestax + fees + this.servicefee
        this.grandtotal = this.basic + this.salestax + this.commission
      }
    },

    // Extract and compute Sabre fares
    sabreFares() {
      this.farebasis = ""
      this.faredetails = []
      this.tstfares = []
      this.basic = 0
      this.salestax = 0
      this.commission = 0
      this.grandtotal = 0
      this.cummulativetotal = 0
      var isSabre360 = false

      // Check if Sabre RED or Sabre 360
      var fareLine = this.filedfares.split("\n")
      for (let r = 0; r < fareLine.length; r++) {
        if (fareLine[r].search("BASE FARE") > 0) {
          isSabre360 = true
          break
        } else if (fareLine[r].search("BASE FARE") === 0) {
          isSabre360 = false
          break
        }
      }
      // SABRE RED FILED FARES
      if (this.filedfares.length > 0 && !isSabre360) {
        // SABRERED
        var fareLine = this.filedfares.split("\n")
        for (let l = 0; l < fareLine.length; l++) {
          var fare = ""
          var cost = 0
          var price = 0
          var equiv = ""
          var conv = 0
          conv = 0
          var taxes = ""
          var tax = 0
          var tots = ""
          var total = 0

          if (fareLine[l].substring(0, 2) == "PQ") {
            var tstno = fareLine[l].substring(0, 4)
            var segmt = fareLine[l].substring(7, fareLine[l].length).trim()
            if (segmt.length == 0) {
              segmt = "ALL"
            }
          }

          if (
            parseInt(fareLine[l].substring(0, 2)) > 0 &&
            parseInt(fareLine[l].substring(11, 16)) > 0
          ) {
            const tstObj = {
              tstno: tstno,
              segment: segmt,
              flightno:
                fareLine[l].substring(9, 11).trim() +
                fareLine[l].substring(11, 15).trim(),
              farebasic: fareLine[l].substring(29, 37).trim(),
              allowance: fareLine[l].substring(60, 63).trim(),
            }
            this.farebasis =
              this.farebasis + " " + fareLine[l].substring(29, 37).trim()
            this.faredetails.push(tstObj)
          }

          if (fareLine[l].substring(60, 63) == "ADT") {
            fare = fareLine[l].substring(0, 15).trim()
            cost = isNaN(parseFloat(fare.substring(3, fare.length)))
              ? 0
              : parseFloat(fare.substring(3, fare.length))

            equiv = fareLine[l].substring(15, 30).trim()
            conv = isNaN(parseFloat(equiv.substring(3, equiv.length)))
              ? 0
              : parseFloat(equiv.substring(3, equiv.length))

            taxes = fareLine[l].substring(30, 45).trim()
            tax = isNaN(parseFloat(taxes.substring(0, taxes.length - 2)))
              ? 0
              : parseFloat(taxes.substring(0, taxes.length - 2))

            tots = fareLine[l].substring(45, 60).trim()
            total = isNaN(parseFloat(tots.substring(3, tots.length)))
              ? 0
              : parseFloat(tots.substring(3, tots.length))

            if (conv > 0) {
              price = conv
            } else {
              price = cost
            }
            const priceObj = {
              tstno: tstno,
              segment: segmt,
              price: this.formatMoney(price),
              tax: this.formatMoney(tax),
              subtotal: 0,
              tstfees: 0,
              tsttotal: 0,
              servicefee: this.formatMoney(this.servicefee),
              total: this.formatMoney(parseFloat(total) + this.servicefee),
            }
            this.tstfares.push(priceObj)
            this.basic = this.basic + price
            this.salestax = this.salestax + tax
            this.commission = this.commission + this.servicefee
          }
        }
        this.cummulativetotal = this.basic + this.salestax + this.servicefee
        this.grandtotal = this.basic + this.salestax + this.commission
      } else if (this.filedfares.length > 0 && isSabre360) {
        // SABRE 360
        var segmt = ""

        var flaggedFare = false
        var fareLine = this.filedfares.split("\n")
        for (let l = 0; l < fareLine.length; l++) {
          var fare = ""
          var cost = 0
          var price = 0
          var equiv = ""
          var conv = 0
          conv = 0
          var taxes = ""
          var tax = 0
          var tots = ""
          var total = 0

          if (
            fareLine[l].substring(0, 2) == "PQ" &&
            fareLine[l].substring(fareLine[l].length - 3, fareLine[l].length) ==
              "ADT"
          ) {
            var tstno = fareLine[l].substring(0, 4)
            this.validity = fareLine[l].substring(31, 43)
            this.validity =
              this.validity.substring(0, 2) +
              "-" +
              this.validity.substring(2, 5) +
              "-" +
              this.validity.substring(5, 7) +
              " / " +
              this.validity.substring(8, 10) +
              ":" +
              this.validity.substring(10, 12)
          }

          if (flaggedFare) {
            fare = fareLine[l].substring(0, 15).trim()
            cost = isNaN(parseFloat(fare.substring(3, fare.length)))
              ? 0
              : parseFloat(fare.substring(3, fare.length))

            equiv = fareLine[l].substring(16, 31).trim()
            conv = isNaN(parseFloat(equiv.substring(3, equiv.length)))
              ? 0
              : parseFloat(equiv.substring(3, equiv.length))

            taxes = fareLine[l].substring(32, 46).trim()
            tax = isNaN(parseFloat(taxes.substring(0, taxes.length - 2)))
              ? 0
              : parseFloat(taxes.substring(0, taxes.length - 2))

            tots = fareLine[l].substring(47, 63).trim()
            total = isNaN(parseFloat(tots.substring(3, tots.length)))
              ? 0
              : parseFloat(tots.substring(3, tots.length))

            if (conv > 0) {
              price = conv
            } else {
              price = cost
            }
            if (segmt.substring(segmt.length - 1, segmt.length) == "/") {
              segmt = segmt.substring(0, segmt.length - 1)
            }
            const priceObj = {
              tstno: tstno,
              segment: segmt,
              price: this.formatMoney(price),
              tax: this.formatMoney(tax),
              subtotal: 0,
              tstfees: 0,
              tsttotal: 0,
              servicefee: this.formatMoney(this.servicefee),
              total: this.formatMoney(parseFloat(total) + this.servicefee),
            }
            this.tstfares.push(priceObj)
            this.basic = this.basic + price
            this.salestax = this.salestax + tax
            this.commission = this.commission + this.servicefee
            segmt = ""
            flaggedFare = false
          }

          if (
            parseInt(fareLine[l].substring(0, 2)) > 0 &&
            parseInt(fareLine[l].substring(10, 14)) > 0
          ) {
            segmt += fareLine[l].substring(0, 2) + "/"
            var tstObj = {
              tstno: tstno,
              segment: fareLine[l].substring(0, 2),
              flightno:
                fareLine[l].substring(8, 10).trim() +
                fareLine[l].substring(10, 14).trim(),
              farebasic: fareLine[l].substring(28, 36).trim(),
              allowance: fareLine[l].substring(60, 63).trim(),
            }
            this.farebasis =
              this.farebasis + " " + fareLine[l].substring(28, 36).trim()

            this.faredetails.push(tstObj)
          }
          if (
            fareLine[l].substring(6, 15) == "BASE FARE" &&
            fareLine[l].substring(58, 63) == "TOTAL"
          ) {
            flaggedFare = true
          }
        }
        this.cummulativetotal = this.basic + this.salestax + this.servicefee
        this.grandtotal = this.basic + this.salestax + this.commission
      }
    },

    // Invoke the decoder
    decodeItinerary() {
      this.today = new Date()
      switch (this.gdsinuse) {
        case "AMADEUS":
          if (this.activeAmadeus) {
            this.amadeusItinerary()
          }
          break
        case "GALILEO":
          if (this.activeGalileo) {
            this.galileoItinerary()
          }
          break
        case "SABRE" && this.activeSabre:
          if (this.activeSabre) {
            this.sabreItinerary()
          }
          break
      }
    },

    // Extract Amadeus itineraries
    async amadeusItinerary() {
      this.itineraries = []
      this.passengers = []
      var rawdata = new Array()
      if (this.itinerary.length > 0) {
        const routeLine = this.itinerary.split("\n")
        for (let i = 0; i < routeLine.length; i++) {
          // Check Passenger names
          if (this.amadeusFlags.includes(routeLine[i].trim().substring(0, 2))) {
            this.passengers.push({ name: routeLine[i].trim() })
          }
          // Check if data is an actual segment line
          if (
            this.airstatus.includes(routeLine[i].substring(29, 31).trim()) &&
            parseInt(routeLine[i].substring(31, 32)) > 0
          ) {
            // Create Itinerary Object
            const segmentObj = {
              slno: routeLine[i].substring(0, 3),
              airline: routeLine[i].substring(5, 7),
              flightno: routeLine[i].substring(7, 11),
              airclass: routeLine[i].substring(12, 13),
              deptdt: routeLine[i].substring(14, 19),
              depttm: routeLine[i].substring(34, 38),
              fromair: routeLine[i].substring(22, 25),
              toair: routeLine[i].substring(25, 28),
              arrvdt: routeLine[i].substring(45, 50),
              arrvtm: routeLine[i].substring(39, 43),
              baggage:
                this.searchBaggage(routeLine[i].substring(5, 11).trim()) == ""
                  ? this.baggage
                  : this.searchBaggage(routeLine[i].substring(5, 11).trim()),
            }
            rawdata.push(segmentObj)
          }
        }
        this.decodeSegments(rawdata)
      }
    },

    // Extract Galileo itineraries
    async galileoItinerary() {
      this.itineraries = []
      this.passengers = []
      var rawdata = new Array()
      if (this.itinerary.length > 0) {
        const routeLine = this.itinerary.split("\n")
        for (let i = 0; i < routeLine.length; i++) {
          // Check Passenger names
          if (
            this.passengerFlags.includes(routeLine[i].trim().substring(0, 3))
          ) {
            this.passengers.push({ name: routeLine[i].trim() })
          }
          // Check if data is an actual segment line
          if (
            this.airstatus.includes(routeLine[i].substring(29, 31).trim()) &&
            parseInt(routeLine[i].substring(31, 32)) > 0
          ) {
            const segmentObj = {
              slno: routeLine[i].substring(0, 3),
              airline: routeLine[i].substring(5, 7),
              flightno: routeLine[i].substring(8, 12),
              airclass: routeLine[i].substring(13, 14),
              deptdt: routeLine[i].substring(16, 21),
              depttm: routeLine[i].substring(34, 38),
              fromair: routeLine[i].substring(22, 25),
              toair: routeLine[i].substring(25, 28),
              arrvdt: this.calcGalileoDate(
                routeLine[i].substring(16, 21),
                routeLine[i].substring(40, 45)
              ),
              arrvtm: routeLine[i].substring(41, 45),
              baggage:
                this.galileoBaggage(routeLine[i].substring(0, 3).trim()) == ""
                  ? this.baggage
                  : this.galileoBaggage(routeLine[i].substring(0, 3).trim()),
            }
            rawdata.push(segmentObj)
          }
        }
        this.decodeSegments(rawdata)
      }
    },

    // Extract Sabre itineraries
    async sabreItinerary() {
      this.itineraries = []
      this.passengers = []
      var rawdata = new Array()
      if (this.itinerary.length > 0) {
        const routeLine = this.itinerary.split("\n")
        for (let i = 0; i < routeLine.length; i++) {
          // Check Passenger names
          if (
            this.passengerFlags.includes(routeLine[i].trim().substring(0, 3))
          ) {
            this.passengers.push({ name: routeLine[i].trim() })
          }
          // Check if data is an actual segment line
          if (
            this.airstatus.includes(routeLine[i].substring(26, 28).trim()) &&
            parseInt(routeLine[i].substring(28, 29)) > 0
          ) {
            const segmentObj = {
              slno: routeLine[i].substring(0, 2),
              airline: routeLine[i].substring(3, 5),
              flightno: routeLine[i].substring(5, 9),
              airclass: routeLine[i].substring(9, 10),
              deptdt: routeLine[i].substring(11, 16),
              depttm: routeLine[i].substring(31, 35),
              fromair: routeLine[i].substring(19, 22),
              toair: routeLine[i].substring(22, 25),
              arrvdt: this.calcSabreDate(
                routeLine[i].substring(11, 16),
                routeLine[i].substring(44, 49)
              ),
              arrvtm: routeLine[i].substring(37, 41),
              baggage:
                this.searchBaggage(
                  routeLine[i].substring(3, 5) +
                    routeLine[i].substring(5, 9).trim()
                ) == ""
                  ? this.baggage
                  : this.searchBaggage(
                      routeLine[i].substring(3, 5) +
                        routeLine[i].substring(5, 9).trim()
                    ),
            }
            rawdata.push(segmentObj)
          }
        }
        this.decodeSegments(rawdata)
      }
    },

    // Decode by fetching Info from DB for the GDS segments
    async decodeSegments(rawdata) {
      this.loading = true
      let decoded = []
      let airlineCode = ""
      let airlineName = ""
      let fromAirport = ""
      let fromCity = ""
      let toAirport = ""
      let toCity = ""
      let airClass = ""

      for (let a = 0; a < rawdata.length; a++) {
        // Get Airline Info
        await firebase
          .firestore()
          .collection("airlines")
          .where("iata", "==", rawdata[a].airline.trim())
          .get()
          .then((snapshot) => {
            snapshot.forEach((doc) => {
              airlineCode = doc.data().iata
              airlineName = doc.data().airline
            })
          })
          .catch((error) => {
            console.error(error)
          })

        // Get From Airport Info
        await firebase
          .firestore()
          .collection("airports")
          .where("iata", "==", rawdata[a].fromair)
          .get()
          .then((snapshot) => {
            snapshot.forEach((doc) => {
              fromAirport = doc.data().airport + " (" + doc.data().iata + ") "
              fromCity = doc.data().location
            })
          })
          .catch((error) => {
            console.error(error)
          })

        // Get To Airport Info
        await firebase
          .firestore()
          .collection("airports")
          .where("iata", "==", rawdata[a].toair)
          .get()
          .then((snapshot) => {
            snapshot.forEach((doc) => {
              toAirport = doc.data().airport + " (" + doc.data().iata + ") "
              toCity = doc.data().location
            })
          })
          .catch((error) => {
            console.error(error)
          })

        // Get Airclass Info
        await firebase
          .firestore()
          .collection("cabins")
          .where("iatacode", "==", rawdata[a].airline)
          .where("cabincode", "==", rawdata[a].airclass)
          .get()
          .then((snapshot) => {
            snapshot.forEach((doc) => {
              airClass = doc.data().cabinname
            })
          })
          .catch((error) => {
            console.error(error)
          })

        // Decoded Object
        decoded.push({
          slno: rawdata[a].slno.trim(),
          iata: airlineCode,
          airline: airlineName,
          flightno: rawdata[a].airline.trim() + rawdata[a].flightno.trim(),
          airclass: airClass,
          fromairport: fromAirport + ", " + fromCity,
          toairport: toAirport + ", " + toCity,
          departure:
            this.formatDates(rawdata[a].deptdt) +
            " " +
            this.formatTime(rawdata[a].depttm),
          arrival:
            this.formatDates(rawdata[a].arrvdt) +
            " " +
            this.formatTime(rawdata[a].arrvtm),
          baggage: rawdata[a].baggage,
        })
      }
      this.itineraries = decoded
      this.loading = false
    },

    // Get global currencies from DB
    async getCurrency() {
      await firebase
        .firestore()
        .collection("currencies")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            const currency = doc.data().code
            this.currencies.push(currency)
          })
        })
        .catch((error) => {
          console.error(error)
        })
    },

    // Format departure and arrival dates
    formatDates(dDate) {
      var moment = require("moment")
      var today = new Date()
      var nMonth = today.getMonth() + 1
      var nYear = today.getFullYear()

      var dMonth = this.convMonth(dDate.substring(2, 5))
      if (parseInt(dMonth) < parseInt(nMonth)) {
        nYear = nYear + 1
      }
      var newDate =
        String(nYear) +
        "-" +
        String(this.convMonth(dDate.substring(2, 5))).padStart(2, 0) +
        "-" +
        String(dDate.substring(0, 2))

      return moment(newDate).format("ddd, DD-MMM-YYYY")
    },

    // Date conversion
    convMonth(strMonth) {
      var mth = 0
      switch (strMonth) {
        case "JAN":
          mth = 1
          break
        case "FEB":
          mth = 2
          break
        case "MAR":
          mth = 3
          break
        case "APR":
          mth = 4
          break
        case "MAY":
          mth = 5
          break
        case "JUN":
          mth = 6
          break
        case "JUL":
          mth = 7
          break
        case "AUG":
          mth = 8
          break
        case "SEP":
          mth = 9
          break
        case "OCT":
          mth = 10
          break
        case "NOV":
          mth = 11
          break
        case "DEC":
          mth = 12
          break
      }
      return mth
    },

    // Compute Arrival Date for Galileo
    calcGalileoDate(depDate, arrTime) {
      var day = parseInt(depDate.trim().substring(0, 2))
      var month = depDate.trim().substring(2, 5)

      if (arrTime.substring(0, 1) == "#") {
        return (day + 1).toString().padStart(2, "0") + month
      } else {
        return day.toString().padStart(2, "0") + month
      }
    },

    // Compute Arrival Date for Sabre
    calcSabreDate(depDate, arrDate) {
      var depDay = parseInt(depDate.trim().substring(0, 2))
      var depMonth = depDate.trim().substring(2, 5)

      if (arrDate.trim().length > 0) {
        var arrDay = parseInt(arrDate.trim().substring(0, 2))
        var arrMonth = arrDate.trim().substring(2, 5)
        if (isNaN(arrDay) && this.convMonth(arrMonth) == 0) {
          return depDay.toString().padStart(2, "0") + depMonth
        } else {
          return arrDay.toString().padStart(2, "0") + arrMonth
        }
      }
    },

    // Format departure & arrival times
    formatTime(theTimes) {
      return theTimes.substring(0, 2) + ":" + theTimes.substring(2, 4)
    },

    // Change case
    titleCase(str) {
      if (str) {
        var splitStr = str.toLowerCase().split(" ")
        for (var i = 0; i < splitStr.length; i++) {
          splitStr[i] =
            splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1)
        }
        // Directly return the joined string
        return splitStr.join(" ")
      } else {
        return ""
      }
    },

    // Find baggage allowance Amadeus & Sabre by Flight No
    searchBaggage(flightNo) {
      if (flightNo.length > 0) {
        let obj = this.faredetails.find(
          (result) => result.flightno === flightNo
        )
        if (obj) {
          return obj.allowance
        } else {
          return ""
        }
      }
    },

    // Find baggage allowance Galileo by TSTNo & Segment No.
    galileoBaggage(segNo) {
      segNo = "S" + segNo
      if (segNo.length > 0) {
        let obj = this.faredetails.find((result) => result.segforbag === segNo)
        if (obj) {
          return obj.allowance
        } else {
          return ""
        }
      }
    },

    // Force numeric input only
    isNumber(event, element) {
      if (!/\d/.test(event.key) && (event.key !== "." || /\./.test(element)))
        return event.preventDefault()

      if (/\.\d{2}/.test(element)) return event.preventDefault()
    },

    // Compute grand total
    calcTotalPrice(event) {
      if (this.cost == "") this.cost = 0
      if (this.servicefee == "") this.servicefee = 0
      this.customtotal = this.airfare + this.tax + this.servicefee
      this.calcGrandTotal()
    },

    // Invoke grand total computation based on GDS in use
    calcGrandTotal() {
      switch (this.gdsinuse) {
        case "AMADEUS":
          this.amadeusFares()
          break
        case "GALILEO":
          this.galileoFares()
          break
        case "SABRE":
          this.sabreFares()
          break
      }
    },

    // Copy to clipboard
    copyClipboard() {
      this.selectText(this.$refs.tocopy)
      document.execCommand("copy")
    },

    // Select range area to copy
    selectText(element) {
      var range
      if (document.selection) {
        // IE
        range = document.body.createTextRange()
        range.moveToElementText(element)
        range.select()
      } else if (window.getSelection) {
        range = document.createRange()
        range.selectNode(element)
        window.getSelection().removeAllRanges()
        window.getSelection().addRange(range)
      }
    },

    // Format currency values
    formatMoney(number, decPlaces, decSep, thouSep) {
      ;(decPlaces = isNaN((decPlaces = Math.abs(decPlaces))) ? 2 : decPlaces),
        (decSep = typeof decSep === "undefined" ? "." : decSep)
      thouSep = typeof thouSep === "undefined" ? "," : thouSep
      var sign = number < 0 ? "-" : ""
      var i = String(
        parseInt((number = Math.abs(Number(number) || 0).toFixed(decPlaces)))
      )
      var j = (j = i.length) > 3 ? j % 3 : 0

      return (
        sign +
        (j ? i.substr(0, j) + thouSep : "") +
        i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
        (decPlaces
          ? decSep +
            Math.abs(number - i)
              .toFixed(decPlaces)
              .slice(2)
          : "")
      )
    },

    // Splits notes by new line
    splitNotes() {
      this.remarks = this.notes.split("\n")
    },

    // Splits notes by new line
    splitAccomodation() {
      this.hotels = this.accomodation.split("\n")
    },

    // Send proposal email
    async mailProposal() {
      var moment = require("moment")
      let company = ""
      let address = ""
      let telno = ""
      let email = ""
      let imageurl = ""
      let mailfooter = ""

      email = firebase.auth().currentUser.email
      company = firebase.auth().currentUser.displayName

      try {
        const uid = await firebase.auth().currentUser.uid
        const user = await firebase
          .firestore()
          .collection("users")
          .doc(uid)
          .get()
        if (user) {
          address = user.data().address
          telno = user.data().telno
          imageurl = user.data().imageurl
          mailfooter = user.data().mailfooter
        } else {
          company = ""
          address = ""
          telno = ""
          imageurl = ""
          mailfooter = ""
        }
      } catch (e) {
        console.log(e)
      }

      let mailHtml = ""

      // ITINERARIES
      mailHtml += `<table cellpadding="5" cellspacing="5" width="800px" style="table-layout: fixed; font-family: 'Roboto'; font-size: 11px; color: #000000; border: 1px solid #000000; border-collapse:collapse">`

      mailHtml += `<colgroup>`
      mailHtml += `<col span="1" style="width: 40px"/>`
      mailHtml += `<col span="1" style="width: 80px" />`
      mailHtml += `<col span="1" style="width: 50px" />`
      mailHtml += `<col span="1" style="width: 70px"/>`
      mailHtml += `<col span="1" style="width: 110px" />`
      mailHtml += `<col span="1" style="width: 150px" />`
      mailHtml += `<col span="1" style="width: 150px"/>`
      mailHtml += `<col span="1" style="width: 110px" />`
      mailHtml += `<col span="1" style="width: 40px" />`
      mailHtml += `</colgroup>`

      mailHtml += `<tr>`
      mailHtml += `<td colspan="2">`
      mailHtml += `<img src="${imageurl}" style="margin-left: auto; margin-right: auto;" alt="Company Logo" width="100" height="100" />`
      mailHtml += `</td>`
      mailHtml += `<td colspan="4">`
      mailHtml += `<div style="font-size: 24px"><strong>${company}</strong></div>`
      mailHtml += `<div style="font-size: 24px">TRAVEL PROPOSAL</div>`
      mailHtml += `</td>`
      mailHtml += `<td style="text-align: right; border-right: 1px solid #000000;" colspan="3">`
      mailHtml += `<p>${address}<br/>`
      mailHtml += `TelNo: ${telno}<br/>`
      mailHtml += `Email: ${email}<br/>`
      mailHtml += `</td>`
      mailHtml += `</tr>`

      mailHtml += `<tr>`
      mailHtml += `<td style="border: 1px solid #000000;" colspan="9">Further to your travel enquiry, we are pleased to provide you with the following travel proposal, please contact us via email or telephone to make a booking or discuss your requirements further.</td>`
      mailHtml += `</tr>`

      // REFERENCE LINE
      if (this.reference.trim().length > 0) {
        mailHtml += `<tr>`
        mailHtml += `<td style="border: 1px solid #000000;"><b>Ref</b></td>`
        mailHtml += `<td style="border: 1px solid #000000;" colspan="8">${this.reference}</td>`
        mailHtml += `</tr>`
      }

      // PASSENGER NAME BLOCK
      if (this.passengers.length > 0) {
        mailHtml += `<tr>`
        mailHtml += `<td style="border: 1px solid #000000;" colspan="9"><b>Passenger(s)</b></td>`
        mailHtml += `</tr>`

        this.passengers.forEach((passenger) => {
          mailHtml += `<tr>`
          mailHtml += `<td style="border: 1px solid #000000;" colspan="9">${passenger.name}</td>`
          mailHtml += `</tr>`
        })
      }

      // ITINERARY LINES
      mailHtml += `<tr>`
      mailHtml += `<td style="border: 1px solid #000000 ;"><b>Item</b></td>`
      mailHtml += `<td style="border: 1px solid #000000 ;"><b>Airline</b></td>`
      mailHtml += `<td style="border: 1px solid #000000 ;"><b>Flt No.</b></td>`
      mailHtml += `<td style="border: 1px solid #000000 ;"><b>Class</b></td>`
      mailHtml += `<td style="border: 1px solid #000000 ;"><b>Departure</b></td>`
      mailHtml += `<td style="border: 1px solid #000000 ;"><b>From</b></td>`
      mailHtml += `<td style="border: 1px solid #000000 ;"><b>To</b></td>`
      mailHtml += `<td style="border: 1px solid #000000 ;"><b>Arrival</b></td>`
      mailHtml += `<td style="border: 1px solid #000000 ;"><b>Bags</b></td>`
      mailHtml += `</tr>`

      this.itineraries.forEach((itinerary) => {
        mailHtml += `<tr style="border: 1px solid #000000;">`
        mailHtml += `<td style="border: 1px solid #000000;">${itinerary.slno}</td>`
        mailHtml += `<td style="border: 1px solid #000000;">${itinerary.airline}</td>`
        mailHtml += `<td style="border: 1px solid #000000;">${itinerary.flightno}</td>`
        mailHtml += `<td style="border: 1px solid #000000;">${itinerary.airclass}</td>`
        mailHtml += `<td style="border: 1px solid #000000;">${itinerary.departure}</td>`
        mailHtml += `<td style="border: 1px solid #000000;">${itinerary.fromairport}</td>`
        mailHtml += `<td style="border: 1px solid #000000;">${itinerary.toairport}</td>`
        mailHtml += `<td style="border: 1px solid #000000;">${itinerary.arrival}</td>`
        mailHtml += `<td style="border: 1px solid #000000;">${itinerary.baggage}</td>`
        mailHtml += `</tr>`
      })

      // FARE BASIS
      if (
        this.rulestabs == "fares-cummulative" ||
        this.rulestabs == "fares-segment"
      ) {
        mailHtml += `<tr style="border: 1px solid #000000;">`
        mailHtml += `<td><b>Fare Basic</b></td>`
        mailHtml += `<td colspan="8" style="border: 1px solid #000000;">${this.farebasis.trim()}</td>`
        mailHtml += `</tr>`
      }

      // MANUAL FARE RULES
      if (this.rulestabs == "fares-manual" && this.showrules) {
        mailHtml += `<tr><td style="border: 1px solid #000000;"><strong>Fare Rules</strong></td>`
        mailHtml += `<td colspan="8">`
        if (this.segments.length > 0) {
          mailHtml += `<table cellpadding="5" cellspacing="5" width="745px" style="font-family: 'Roboto'; font-size: 11px; color: #000000; border: 1px solid #000000; border-collapse:collapse">`
          mailHtml += `<tr><td width="50px" style="border: 1px solid #000000;"><b>Airline</b></td>`
          mailHtml += `<td width="75px" style="border: 1px solid #000000;"><b>Flight No.</b></td>`
          mailHtml += `<td width="620px" style="border: 1px solid #000000;"><b>Fare Rules</b></td></tr>`
          this.segments.forEach((segment) => {
            mailHtml += `<tr>`
            mailHtml += `<td style="border: 1px solid #000000;">${segment.iatacode}</td>`
            mailHtml += `<td style="border: 1px solid #000000;">${segment.flightno}</td>`
            mailHtml += `<td style="border: 1px solid #000000;">`
            if (segment.farerule.length > 0) {
              segment.farerule.forEach((frule) => {
                mailHtml += `<div>${frule}</div>`
              })
            }
            mailHtml += `</td>`
            mailHtml += `</tr>`
          })

          mailHtml += `</table>`
        }
        mailHtml += `</td></tr>`
      }

      // CUMMULATIVE FARE RULES
      if (this.rulestabs == "fares-cummulative" && this.showrules) {
        mailHtml += `<tr><td style="border: 1px solid #000000;"><strong>Fare Rules</strong></td>`
        mailHtml += `<td colspan="8">`
        if (this.tstfares.length > 0) {
          mailHtml += `<table cellpadding="5" cellspacing="5" width="745px" style="font-family: 'Roboto'; font-size: 11px; color: #000000; border: 1px solid #000000; border-collapse:collapse">`
          mailHtml += `<tr><td width="50px" style="border: 1px solid #000000;"><b>Item</b></td>`
          mailHtml += `<td width="695px" style="border: 1px solid #000000;"><b>Fare Rules</b></td></tr>`
          this.tstfares.forEach((tstfare) => {
            mailHtml += `<tr>`
            mailHtml += `<td style="border: 1px solid #000000;">${tstfare.segment}</td>`
            mailHtml += `<td style="border: 1px solid #000000;">`
            tstfare.farerule.forEach((frule) => {
              mailHtml += `<div>${frule}</div>`
            })
            mailHtml += `</td>`
            mailHtml += `</tr>`
          })

          mailHtml += `</table>`
        }
        mailHtml += `</td></tr>`
      }

      // SEGMENT-WISE FARES WITH FARE RULES
      if (this.rulestabs == "fares-segment" && this.showrules) {
        mailHtml += `<tr>`
        mailHtml += `<td><strong>Fare ${this.currencylocal}</strong></td>`
        if (this.tstfares.length > 0) {
          if (this.farebreakup == "NETFARE") {
            mailHtml += `<td colspan="8" style="border: 1px solid #000000;">`
            mailHtml += `<table cellpadding="5" cellspacing="5" width="745px" style="font-family: 'Roboto'; font-size: 11px; color: #000000; border: 1px solid #000000; border-collapse:collapse">`
            mailHtml += `<tr><td width="50px" style="border: 1px solid #000000;"><b>Item</b></td>`
            mailHtml += `<td width="75px" style="text-align: right; border: 1px solid #000000;"><b>Grand Total</b></td>`
            mailHtml += `<td width="620px" style="border: 1px solid #000000;"><b>Fare Rules</b></td></tr>`
            this.tstfares.forEach((tstfare) => {
              mailHtml += `<tr>`
              mailHtml += `<td style="border: 1px solid #000000;">${tstfare.segment}</td>`
              mailHtml += `<td style="text-align: right; border: 1px solid #000000;"><strong>${tstfare.total}</strong></td>`
              mailHtml += `<td style="border: 1px solid #000000;">`
              tstfare.farerule.forEach((frule) => {
                mailHtml += `<div>${frule}</div>`
              })
              mailHtml += `</td>`
              mailHtml += `</tr>`
            })
            mailHtml += `</table>`
            mailHtml += `</td></tr>`
          }

          if (this.farebreakup == "DETFARE") {
            mailHtml += `<td colspan="8" style="border: 1px solid #000000;">`
            mailHtml += `<table cellpadding="5" cellspacing="5" width="745px" style="font-family: 'Roboto'; font-size: 11px; color: #000000; border: 1px solid #000000; border-collapse:collapse">`
            mailHtml += `<tr><td width="50px" style="border: 1px solid #000000;"><b>Item</b></td>`
            mailHtml += `<td width="75px" style="text-align: right; border: 1px solid #000000;"><b>Base Fare</b></td>`
            mailHtml += `<td width="75px" style="text-align: right; border: 1px solid #000000;"><b>Tax</b></td>`
            mailHtml += `<td width="75px" style="text-align: right; border: 1px solid #000000;"><b>Service Fee</b></td>`
            mailHtml += `<td width="75px" style="text-align: right; border: 1px solid #000000;"><b>Grand Total</b></td>`
            mailHtml += `<td width="395px" style="border: 1px solid #000000;"><b>Fare Rules</b></td></tr>`
            this.tstfares.forEach((tstfare) => {
              mailHtml += `<tr>`
              mailHtml += `<td style="border: 1px solid #000000;">${tstfare.segment}</td>`
              mailHtml += `<td style="text-align: right; border: 1px solid #000000;"><strong>${tstfare.price}</strong></td>`
              mailHtml += `<td style="text-align: right; border: 1px solid #000000;"><strong>${tstfare.tax}</strong></td>`
              mailHtml += `<td style="text-align: right; border: 1px solid #000000;"><strong>${tstfare.servicefee}</strong></td>`
              mailHtml += `<td style="text-align: right; border: 1px solid #000000;"><strong>${tstfare.total}</strong></td>`
              mailHtml += `<td style="border: 1px solid #000000;">`
              tstfare.farerule.forEach((frule) => {
                mailHtml += `<div>${frule}</div>`
              })
              mailHtml += `</td>`
              mailHtml += `</tr>`
            })
            mailHtml += `</table>`
            mailHtml += `</td></tr>`
          }
        }
      }

      // SEGMENT-WISE FARES WITHOUT FARE RULES
      if (this.rulestabs == "fares-segment" && !this.showrules) {
        mailHtml += `<tr>`
        mailHtml += `<td><strong>Fare Rules</strong></td>`
        if (this.tstfares.length > 0) {
          if (this.farebreakup == "NETFARE") {
            mailHtml += `<td colspan="8" style="border: 1px solid #000000;">`
            mailHtml += `<table cellpadding="5" cellspacing="5" width="745px" style="font-family: 'Roboto'; font-size: 11px; color: #000000; border: 1px solid #000000; border-collapse:collapse">`
            mailHtml += `<tr><td width="50px" style="border: 1px solid #000000;"><b>Item</b></td>`
            mailHtml += `<td width="80px" style="text-align: right; border: 1px solid #000000;"><b>Grand Total</b></td>`
            this.tstfares.forEach((tstfare) => {
              mailHtml += `<tr>`
              mailHtml += `<td style="border: 1px solid #000000;">${tstfare.segment}</td>`
              mailHtml += `<td style="text-align: right;border: 1px solid #000000;">${tstfare.total}</td>`
              mailHtml += `</tr>`
            })
            mailHtml += `</table>`
            mailHtml += `</td></tr>`
          }

          if (this.farebreakup == "DETFARE") {
            mailHtml += `<td colspan="8" style="border: 1px solid #000000;">`
            mailHtml += `<table cellpadding="5" cellspacing="5" width="745px" style="font-family: 'Roboto'; font-size: 11px; color: #000000; border: 1px solid #000000; border-collapse:collapse">`
            mailHtml += `<tr><td width="50px" style="border: 1px solid #000000;"><b>Item</b></td>`
            mailHtml += `<td width="75px" style="text-align: right; border: 1px solid #000000;"><b>Base Fare</b></td>`
            mailHtml += `<td width="75px" style="text-align: right; border: 1px solid #000000;"><b>Tax</b></td>`
            mailHtml += `<td width="75px" style="text-align: right; border: 1px solid #000000;"><b>Service Fee</b></td>`
            mailHtml += `<td width="80px" style="text-align: right; border: 1px solid #000000;"><b>Grand Total</b></td>`
            this.tstfares.forEach((tstfare) => {
              mailHtml += `<tr>`
              mailHtml += `<td style="border: 1px solid #000000;">${tstfare.segment}</td>`
              mailHtml += `<td style="text-align: right; border: 1px solid #000000;"><strong>${tstfare.price}</strong></td>`
              mailHtml += `<td style="text-align: right; border: 1px solid #000000;"><strong>${tstfare.tax}</strong></td>`
              mailHtml += `<td style="text-align: right; border: 1px solid #000000;"><strong>${tstfare.servicefee}</strong></td>`
              mailHtml += `<td style="text-align: right; border: 1px solid #000000;"><strong>${tstfare.total}</strong></td>`
              mailHtml += `</tr>`
            })
            mailHtml += `</table>`
            mailHtml += `</td></tr>`
          }
        }
      }

      // MANUAL FARES
      if (this.rulestabs == "fares-manual") {
        mailHtml += `<tr><td style="border: 1px solid #000000;"><strong>Fare ${this.currencylocal}</strong></td>`
        if (this.farebreakup == "NETFARE") {
          mailHtml += `<td colspan="8" style="border: 1px solid #000000;"><strong>${this.formatMoney(
            this.customtotal
          )}</strong></td>`
        }
        if (this.farebreakup == "DETFARE") {
          mailHtml += `<td colspan="8" style="border: 1px solid #000000;">`
          mailHtml += `<table cellpadding="5" cellspacing="5" width="745px" style="font-family: 'Roboto'; font-size: 11px; color: #000000; border: 1px solid #000000; border-collapse:collapse">`
          mailHtml += `<tr><td width="180px" style="text-align: right; border: 1px solid #000000;"><strong>Base Fare</strong></td>`
          mailHtml += `<td width="180px" style="text-align: right; border: 1px solid #000000;"><strong>Tax</strong></td>`
          mailHtml += `<td width="180px" style="text-align: right; border: 1px solid #000000;"><strong>Service Fee</strong></td>`
          mailHtml += `<td width="185px" style="text-align: right; border: 1px solid #000000;"><strong>Grand Total</strong></td></tr>`
          mailHtml += `<tr><td style="text-align: right; border: 1px solid #000000;"><strong>${this.formatMoney(
            this.airfare
          )}</strong></td>`
          mailHtml += `<td style="text-align: right; border: 1px solid #000000;"><strong>${this.formatMoney(
            this.tax
          )}</strong></td>`
          mailHtml += `<td style="text-align: right; border: 1px solid #000000;"><strong>${this.formatMoney(
            this.servicefee
          )}</strong></td>`
          mailHtml += `<td style="text-align: right; border: 1px solid #000000;"><strong>${this.formatMoney(
            this.customtotal
          )}</strong></td></tr>`
          mailHtml += `</table></td>`
        }
        mailHtml += `</tr>`
      }

      // CUMMULATIVE FARES
      if (this.rulestabs == "fares-cummulative") {
        mailHtml += `<tr><td><strong>Fare ${this.currencylocal}</strong></td>`
        if (this.farebreakup == "NETFARE") {
          mailHtml += `<td colspan="8" style="border: 1px solid #000000;"><strong>${this.formatMoney(
            this.cummulativetotal
          )}</strong></td>`
        }
        if (this.farebreakup == "DETFARE") {
          mailHtml += `<td colspan="8" style="border: 1px solid #000000;">`
          mailHtml += `<table cellpadding="5" cellspacing="5" width="745px" style="font-family: 'Roboto'; font-size: 11px; color: #000000; border: 1px solid #000000; border-collapse:collapse">`
          mailHtml += `<tr><td width="180px" style="text-align: right; border: 1px solid #000000;"><strong>Base Fare</strong></td>`
          mailHtml += `<td width="180px" style="text-align: right; border: 1px solid #000000;"><strong>Tax</strong></td>`
          mailHtml += `<td width="180px" style="text-align: right; border: 1px solid #000000;"><strong>Service Fee</strong></td>`
          mailHtml += `<td width="185px" style="text-align: right; border: 1px solid #000000;"><strong>Grand Total</strong></td></tr>`
          mailHtml += `<tr><td style="text-align: right; border: 1px solid #000000;"><strong>${this.formatMoney(
            this.basic
          )}</strong></td>`
          mailHtml += `<td style="text-align: right; border: 1px solid #000000;"><strong>${this.formatMoney(
            this.salestax
          )}</strong></td>`
          mailHtml += `<td style="text-align: right; border: 1px solid #000000;"><strong>${this.formatMoney(
            this.servicefee
          )}</strong></td>`
          mailHtml += `<td style="text-align: right; border: 1px solid #000000;"><strong>${this.formatMoney(
            this.cummulativetotal
          )}</strong></td></tr>`
          mailHtml += `</table></td>`
        }
        mailHtml += `</tr>`
      }

      // FARE VALIDITY
      if (this.validity.length > 0) {
        mailHtml += `<tr><td style="border: 1px solid #000000;"><b>Valid</b></td>`
        mailHtml += `<td colspan="8" style="border: 1px solid #000000;">${this.validity}`
        mailHtml += `</td></tr>`
      }

      // ACCOMODATION/HOTELS
      if (this.hotels.length > 0) {
        mailHtml += `<tr><td style="border: 1px solid #000000;"><b>Stay</b></td>`
        mailHtml += `<td colspan="8" style="border: 1px solid #000000;">`
        this.hotels.forEach((hotel) => {
          mailHtml += `<div>${hotel}</div>`
        })
        mailHtml += `</td></tr>`
      }

      // NOTES/REMARKS
      if (this.remarks.length > 0) {
        mailHtml += `<tr><td style="border: 1px solid #000000;"><b>Notes</b></td>`
        mailHtml += `<td colspan="8" style="border: 1px solid #000000;">`
        this.remarks.forEach((remark) => {
          mailHtml += `<div>${remark}</div>`
        })
        mailHtml += `</td></tr>`
      }

      // COPYRIGHT FOOTER
      mailHtml += `<tr><td colspan="9" style="border: 1px solid #000000;">Copyright &copy; 2020 transformPNR.&nbsp; Fares quoted subject to availability and exchange rates. ${moment(
        new Date(),
        "dddd, MMMM Do YYYY H:mm"
      )}</td></tr>`
      mailHtml += `</table><br/><br/>`
      mailHtml += `Best regards,<br/>`
      mailHtml += `<b>${company} Team</b><br/><br/><br/>`

      // CUSTOM MAIL FOOTER SETUP IN USER PROFILE
      mailHtml += `<table cellpadding="5" cellspacing="5" width="800px" style="font-family: 'Roboto'; font-size: 11px; color: #000000; border: none; border-collapse:collapse">`
      mailHtml += `<tr><td>${mailfooter}</td></tr>`
      mailHtml += `</table></br>`

      let mailBody = {
        company: company,
        emailFrom: "Travel Proposal <travelproposal@transformpnr.com>",
        defaultEmail: email,
        emailTo: this.toemail,
        ccEmail: this.ccemail,
        message: mailHtml,
      }

      if (
        this.passengers.length > 0 &&
        this.itineraries.length > 0 &&
        this.segments.length > 0 &&
        this.tstfares.length > 0
      ) {
        try {
          let response = axios.post(
            "https://europe-west1-aej-travels-60acd.cloudfunctions.net/sendProposalMail",
            mailBody
          )
          this.$vToastify.success(
            `Proposal has been successfully sent.`,
            "INFO!"
          )
          this.dialog = false
        } catch (e) {
          this.$vToastify.error(
            `Failed to send proposal. Try again later.`,
            "INFO!"
          )
          this.dialog = false
        }
      }
    },

    //Update date & time
    updateTime() {
      this.today = new Date()
    },

    // Reset form data
    resetForm() {
      this.today = new Date()
      this.valid = true
      this.dialog = false
      this.loading = false
      this.farebreakup = "NETFARE"
      this.rulestabs = null
      this.showrules = false
      this.passengers = []
      this.itinerary = ""
      this.filedfares = ""
      this.airfare = 0
      this.tax = 0
      this.servicefee = 0
      this.baggage = ""
      this.validity = ""
      this.accomodation = ""
      this.hotels = []
      this.notes = ""
      this.remarks = []
      this.farebasis = ""
      this.itineraries = []
      this.segments = []
      this.faredetails = []
      this.tstfares = []
      this.customtotal = 0
      this.cummulativetotal = 0
      this.basic = 0
      this.salestax = 0
      this.commission = 0
      this.grandtotal = 0
      this.toemail = ""
      this.ccemail = ""
      this.reference = ""
      window.getSelection().removeAllRanges()
      this.getUser()
    },
  },
}
</script>

<style scoped>
table {
  table-layout: fixed;
  font-size: 11px;
  color: #000000;
  border-collapse: collapse;
  width: 800px;
  margin: 0;
  padding: 0;
}

td,
th {
  border: 1px solid #000000;
  text-align: left;
  padding: 4px;
}

tr:nth-child(even) {
  background-color: #f1f1f1;
}

.v-btn {
  color: rgb(255, 255, 255) !important;
  background-color: #0b2545 !important;
}
.theme--light.v-btn--disabled {
  color: rgb(255, 255, 255) !important;
  background-color: #b8b8b8 !important;
}
</style>
